module.exports = __webpack_public_path__ + "static/img/zt3-pic4.aaa6703.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceThree/zt3-pic4.jpg
// module id = HbWn
// module chunks = 171